module.exports = __webpack_public_path__ + "static/img/5.6d7e96a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/5.png
// module id = 6VR3
// module chunks = 1